import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { AppBox } from "../../../commons/components";
import { StandingBracket } from "../../../commons/components/ui-components/StandingBracket";
import { fetchManageSeasonKnockoutList } from "../../../redux/slices/football/admin/season/knockout/manage-knockout-list-slice";
import { useParams } from "react-router";

export const MatchDetailBrackets = () => {
  const dispatch = useAppDispatch();
  const { teamId } = useParams();
  const { seasonMatchDetail } = useAppSelector((state) => state.footballManageSeasonMatchDetail);
  const { seasonKnockoutList } = useAppSelector((state) => state.footballSeasonKnockoutList);

  useEffect(() => {
    if (seasonMatchDetail.season) {
      dispatch(
        fetchManageSeasonKnockoutList({
          seasonId: seasonMatchDetail.season.id,
          urlParams: {
            hostTeamId: teamId?Number(teamId):undefined,
          },
        })
      );
    }
  }, [seasonMatchDetail]);

  return (
    <AppBox gap="sm" flexDirection="column">
      <StandingBracket knockoutTree={seasonKnockoutList} isManage competition={seasonMatchDetail.competition} />
    </AppBox>
  );
};
